import { JsonConverter, JsonCustomConvert } from 'json2typescript';

import { SelectedProductStatus } from '../../../../../core';

@JsonConverter
export class SelectedProductStatusAdapter implements JsonCustomConvert<SelectedProductStatus> {
    serialize(status: SelectedProductStatus): any {
        return status ? String(status) : undefined;
    }

    deserialize(status: any): SelectedProductStatus {
        switch (status) {
            case 'ACCEPTED':
                return SelectedProductStatus.ACCEPTED;
            case 'ACTIVE':
                return SelectedProductStatus.ACTIVE;
            case 'CANCELED':
                return SelectedProductStatus.CANCELED;
            case 'ERROR':
                return SelectedProductStatus.ERROR;
            case 'EXECUTED':
                return SelectedProductStatus.EXECUTED;
            case 'EXPIRED':
                return SelectedProductStatus.EXPIRED;
            case 'FOR_SIGNING':
                return SelectedProductStatus.FOR_SIGNING;
            case 'INPROCESS':
                return SelectedProductStatus.IN_PROCESS;
            case 'NON SUCCESSFUL SIGNATURE':
                return SelectedProductStatus.NON_SUCCESSFUL_SIGNATURE;
            case 'REJECTED':
                return SelectedProductStatus.REJECTED;
            default:
                return SelectedProductStatus.DRAFT;
        }
    }
}
